import React, { useState } from 'react';
import { signInWithEmailAndPassword, signOut } from 'firebase/auth'; 
import { auth, db } from '../firebase'; 
import { doc, getDoc } from 'firebase/firestore'; 
import { Link, useNavigate } from 'react-router-dom';
import { FiEye, FiEyeOff, FiUser, FiHome } from 'react-icons/fi';
import { ALLOWED_UIDS } from '../constants/Whitelist'; // ÚJ IMPORT

const LoginForm = ({ onClose, isEmbedded = false }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [isFieldError, setIsFieldError] = useState(false);
  
  const [loginMode, setLoginMode] = useState('user'); 
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    // ... [existing handleSubmit logic] ...
    e.preventDefault();
    setError('');
    setIsFieldError(false);
    setLoading(true);

    try {
      // 1. Alap hitelesítés (Firebase Auth)
      const userCredential = await signInWithEmailAndPassword(auth, email, password);
      const user = userCredential.user;

      // --- ÚJ: PRIVÁT BÉTA ELLENŐRZÉS (SOROMPÓ) ---
      if (!ALLOWED_UIDS.includes(user.uid)) {
        await signOut(auth);
        setError('⚠️ A weboldal jelenleg privát béta fázisban van. Csak a kijelölt tesztelők léphetnek be.');
        setIsFieldError(true);
        setLoading(false);
        return;
      }

      // 2. SZIGORÚ ELLENŐRZÉS: Jó kollekcióban van-e?
      const collectionName = loginMode === 'user' ? 'users' : 'Clubs';
      const docRef = doc(db, collectionName, user.uid);
      const docSnap = await getDoc(docRef);

      if (!docSnap.exists()) {
        // Ha rossz fülön próbálkozik: AZONNAL KIJELENTKEZTETJÜK
        await signOut(auth);
        
        // Beállítjuk a hibaüzenetet
        setError(loginMode === 'user' 
          ? '⚠️ Nincs ilyen regisztrált VERSENYZŐ. Próbáld meg az Egyesület fület!' 
          : '⚠️ Nincs ilyen regisztrált EGYESÜLET. Próbáld meg a Versenyző fület!');
        
        setIsFieldError(true);
        setLoading(false); 
        return; // <--- ITT A LÉNYEG: Megállítjuk a függvényt, így NEM fut le az onClose()
      }

      // 3. Ha idáig eljutott, minden rendben (Auth + Firestore is OK)
      localStorage.setItem('archery_nexus_role', loginMode); // Mentjük a szerepkört offline használathoz
      setIsLoggedIn(true);
      setLoading(false);

      setTimeout(() => {
        // Csak sikeres belépés ÉS ellenőrzés után zárjuk be
        if (onClose) onClose();
        navigate(loginMode === 'club' ? '/egyesulet-dashboard' : '/profil');
      }, 1500);

    } catch (err) {
      console.error('❌ Hiba:', err.code);
      setLoading(false);
      setIsFieldError(true);
      
      // Kezeljük a konkrét Auth hibákat
      if (err.code === 'auth/wrong-password' || err.code === 'auth/user-not-found' || err.code === 'auth/invalid-credential') {
        setError('❌ Hibás email vagy jelszó!');
      } else if (err.code === 'auth/too-many-requests') {
        setError('❌ Túl sok próbálkozás. Kérlek várj egy kicsit!');
      } else {
        setError('❌ Hiba történt a bejelentkezés során!');
      }
    }
  };

  const tabStyle = (mode) => ({
    flex: 1,
    padding: '12px',
    cursor: 'pointer',
    border: 'none',
    fontSize: '0.9rem',
    fontWeight: 'bold',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '8px',
    transition: '0.3s',
    backgroundColor: loginMode === mode ? '#fff' : '#f2f2f2',
    color: loginMode === mode ? '#b30000' : '#666',
    borderBottom: loginMode === mode ? 'none' : '2px solid #b30000',
    borderRadius: mode === 'user' ? '8px 0 0 0' : '0 8px 0 0',
  });

  return (
    <div
      style={isEmbedded ? {
        backgroundColor: '#fff',
        borderRadius: '12px',
        width: '100%',
        fontFamily: 'Arial, sans-serif',
        boxSizing: 'border-box',
        overflow: 'hidden',
        marginTop: '10px',
        border: '1px solid #ddd'
      } : {
        position: 'absolute',
        top: '70px',
        right: '20px',
        backgroundColor: '#fff',
        borderRadius: '8px',
        boxShadow: '0 8px 24px rgba(0,0,0,0.2)',
        zIndex: 1000,
        width: '320px',
        fontFamily: 'Arial, sans-serif',
        boxSizing: 'border-box',
        overflow: 'hidden'
      }}
      onClick={(e) => e.stopPropagation()} // Megakadályozza, hogy az ablak bezáródjon, ha rákattintasz
    >
      {/* --- PIROS FÜLEK A TETEJÉN --- */}
      <div style={{ display: 'flex', backgroundColor: '#b30000' }}>
        <button 
          type="button" 
          onClick={() => { setLoginMode('user'); setError(''); setIsFieldError(false); }} 
          style={tabStyle('user')}
        >
          <FiUser /> Versenyző
        </button>
        <button 
          type="button" 
          onClick={() => { setLoginMode('club'); setError(''); setIsFieldError(false); }} 
          style={tabStyle('club')}
        >
          <FiHome /> Egyesület
        </button>
      </div>

      <div style={{ padding: '1.5rem' }}>
        <h3 style={{ marginBottom: '1.2rem', color: '#b30000', textAlign: 'center', marginTop: '0' }}>
          {loginMode === 'user' ? 'Versenyző Belépés' : 'Egyesületi Belépés'}
        </h3>

        <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '0.8rem' }}>
          <input
            type="email"
            placeholder={loginMode === 'user' ? "Email címed" : "Egyesületi email"}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            style={{
              padding: '0.75rem',
              fontSize: '1rem',
              borderRadius: '6px',
              border: isFieldError ? '2px solid #ff4d4f' : '1px solid #ddd',
              backgroundColor: isFieldError ? '#fff2f0' : '#fff',
              boxSizing: 'border-box',
              transition: '0.3s'
            }}
          />

          <div style={{ position: 'relative', width: '100%' }}>
            <input
              type={showPassword ? 'text' : 'password'}
              placeholder="Jelszó"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              style={{
                padding: '0.75rem',
                fontSize: '1rem',
                borderRadius: '6px',
                border: isFieldError ? '2px solid #ff4d4f' : '1px solid #ddd',
                backgroundColor: isFieldError ? '#fff2f0' : '#fff',
                width: '100%',
                paddingRight: '2.5rem',
                boxSizing: 'border-box',
                transition: '0.3s'
              }}
            />
            <button
              type="button"
              onClick={() => setShowPassword(!showPassword)}
              style={{
                position: 'absolute',
                right: '0.5rem',
                top: '50%',
                transform: 'translateY(-50%)',
                background: 'none',
                border: 'none',
                cursor: 'pointer',
                color: '#666'
              }}
            >
              {showPassword ? <FiEyeOff size={18} /> : <FiEye size={18} />}
            </button>
          </div>

          {/* HIBAÜZENET PANEL - KÖZVETLENÜL A GOMB FELETT */}
          {error && (
            <div style={{ 
              backgroundColor: '#fff1f0',
              border: '1px solid #ffa39e',
              color: '#cf1322',
              padding: '10px',
              borderRadius: '6px',
              fontSize: '0.82rem', 
              textAlign: 'center', 
              fontWeight: 'bold',
              lineHeight: '1.4',
              margin: '5px 0'
            }}>
              {error}
            </div>
          )}

          <button
            type="submit"
            disabled={loading}
            style={{
              backgroundColor: '#b30000',
              color: 'white',
              padding: '0.8rem',
              fontWeight: 'bold',
              border: 'none',
              borderRadius: '6px',
              cursor: loading ? 'not-allowed' : 'pointer',
              opacity: loading ? 0.7 : 1,
              marginTop: '0.5rem',
              fontSize: '1rem'
            }}
          >
            {loading ? 'Ellenőrzés...' : 'Bejelentkezés'}
          </button>

          {isLoggedIn && (
            <div style={{ color: '#2e7d32', fontSize: '0.9rem', textAlign: 'center', fontWeight: 'bold' }}>
              ✅ Sikeres belépés...
            </div>
          )}
        </form>

        <div style={{ marginTop: '1.2rem', textAlign: 'center', fontSize: '0.85rem' }}>
          <Link 
            to="/jelszovisszaallitas" 
            onClick={onClose}
            style={{ color: '#b30000', textDecoration: 'none', display: 'block', marginBottom: '8px' }}
          >
            Elfelejtetted a jelszavad?
          </Link>
          <span style={{ color: '#666' }}>Nincs még fiókod? </span>
          <Link 
            to="/regisztracio" 
            onClick={onClose}
            style={{ color: '#b30000', fontWeight: 'bold', textDecoration: 'none' }}
          >
            Regisztráció
          </Link>
        </div>
      </div>
    </div>
  );
};

export default LoginForm;